import { useState, useCallback, useRef } from 'react';

/**
 * Tracks whether form data differs from its saved state.
 * @param {object} initialValues - The saved/committed form values
 * @returns {{ isDirty, savedValues, markDirty, markClean, resetTo }}
 */
export default function useDirtyForm(initialValues) {
    const savedRef = useRef(initialValues);
    const [isDirty, setIsDirty] = useState(false);

    const markDirty = useCallback(() => setIsDirty(true), []);
    const markClean = useCallback(() => setIsDirty(false), []);

    const resetTo = useCallback((newValues) => {
        savedRef.current = newValues;
        setIsDirty(false);
    }, []);

    return {
        isDirty,
        savedValues: savedRef.current,
        markDirty,
        markClean,
        resetTo,
    };
}
